<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { computed, inject, ref } from "vue"
import { useRouter } from "vue-router"
import { useAuth } from "@/app/Checkout/composables/useAuth"
import { useCheckout } from "@/app/Checkout/composables/useCheckout"
import { useAddresses } from "@/app/Checkout/composables/useAddresses"
import NBToggle from "@/app/Checkout/components/common/NBToggle/index.vue"

const router = useRouter()
const { isLoggedIn } = useAuth()
const { checkout, hideInvoiceAddress } = useCheckout()
const { errors, mapAddressID, isAddressValid, enrichedAddresses, getAddressString, addressParamIsInvalid, isBillingAddressSame } = useAddresses()
const showDeliveryAddressRequiredError = inject('checkoutShowDeliveryAddressRequired', ref(false))
const showInvoiceAddressRequiredError = inject('checkoutShowInvoiceAddressRequired', ref(false))
const isShippingAddressRequired = computed(
  () => showPlaceholder('delivery_address') && showDeliveryAddressRequiredError.value,
)
const isShippingAddressInvalid = computed(
  () =>
    !showPlaceholder('delivery_address') &&
    getAddressString('delivery_address').length &&
    (addressParamIsInvalid('delivery_address') || (!isLoggedIn.value && !checkout.value?.delivery_address?.email)),
)
const isInvoiceAddressRequired = computed(
  () =>
    !isBillingAddressSame.value &&
    showPlaceholder('invoice_address') &&
    showInvoiceAddressRequiredError.value,
)
const isInvoiceAddressInvalid = computed(
  () =>
    !showPlaceholder('invoice_address') &&
    getAddressString('invoice_address').length &&
      (addressParamIsInvalid('invoice_address') || (!isLoggedIn.value && !checkout.value?.invoice_address?.email)),
)

const updateAddress = (type) => {
  if (enrichedAddresses.value?.length) {
    router.push({ name: 'AddressList', query: { type } })
  } else {
    router.push({ name: 'AddAddress', query: { type } })
  }
}

const showPlaceholder = (addressType) => {
  if (isLoggedIn.value) {
    return !Boolean(mapAddressID(addressType))
  } else if (checkout.value) {
    const address = checkout.value[addressType]

    return !(address.gender || address.firstname || address.lastname)
  }

  return true
}
</script>
